import api from "./api";

// The company spend ledger: advertising, rent, cloud bills, subscriptions - one set of
// endpoints for every head, with the head held as a category code.
const url = "/api/admin/expenses";

export const PAYMENT_METHODS = ["UPI", "BANK_TRANSFER", "CARD", "CASH", "AUTO_DEBIT", "OTHER"];

export const listExpenses = async ({ category, fromDate, toDate, vendor } = {}) => {
  const { data } = await api.get(url, {
    params: {
      category: category || undefined,
      fromDate,
      toDate,
      vendor: vendor || undefined,
    },
  });
  return Array.isArray(data) ? data : [];
};

export const getExpenseSummary = async ({ category, fromDate, toDate } = {}) => {
  const { data } = await api.get(`${url}/summary`, {
    params: { category: category || undefined, fromDate, toDate },
  });
  return data;
};

/** repeatMonths creates the same entry once a month, for a rent or subscription. */
// repeat: { everyMonth, until } sets a new entry repeating monthly the way its head is configured.
export const saveExpense = async (expense, repeatMonths, repeat = null) => {
  if (expense.id) {
    const { data } = await api.put(`${url}/${expense.id}`, expense);
    return [data];
  }
  const params = repeat?.everyMonth
    ? {
        repeatEveryMonth: true,
        ...(repeat.until ? { repeatUntil: repeat.until } : {}),
        ...(repeat.mode ? { repeatMode: repeat.mode } : {}),
      }
    : repeatMonths && repeatMonths > 1 ? { repeatMonths } : {};
  const { data } = await api.post(url, expense, { params });
  return Array.isArray(data) ? data : [data];
};

// Sets an expense already saved repeating monthly from its own date.
export const repeatExistingExpense = async (id, repeat = {}) => {
  const params = {
    ...(repeat.until ? { repeatUntil: repeat.until } : {}),
    ...(repeat.mode ? { repeatMode: repeat.mode } : {}),
  };
  const { data } = await api.post(`${url}/${id}/repeat`, null, { params });
  return data;
};

// Monthly repeating expenses. Opening the list also posts any automatic month that is due.
export const listRecurringExpenses = async () => {
  const { data } = await api.get(`${url}/recurring`);
  return Array.isArray(data) ? data : [];
};

export const listDueRecurringExpenses = async () => {
  const { data } = await api.get(`${url}/recurring/due`);
  return Array.isArray(data) ? data : [];
};

export const confirmRecurringExpense = async (id, offset, payload) => {
  const { data } = await api.post(`${url}/recurring/${id}/confirm`, payload, { params: { offset } });
  return data;
};

export const skipRecurringExpense = async (id, offset) => {
  const { data } = await api.post(`${url}/recurring/${id}/skip`, {}, { params: { offset } });
  return data;
};

export const stopRecurringExpense = async (id) => {
  const { data } = await api.post(`${url}/recurring/${id}/stop`, {});
  return data;
};

export const deleteExpense = async (id) => {
  const { data } = await api.delete(`${url}/${id}`);
  return data;
};

export const listExpenseCategories = async (activeOnly = true) => {
  const { data } = await api.get(`${url}/categories`, { params: { activeOnly } });
  return Array.isArray(data) ? data : [];
};

export const saveExpenseCategory = async (category) => {
  if (category.id) {
    const { data } = await api.put(`${url}/categories/${category.id}`, category);
    return data;
  }
  const { data } = await api.post(`${url}/categories`, category);
  return data;
};

export const deleteExpenseCategory = async (id) => {
  const { data } = await api.delete(`${url}/categories/${id}`);
  return data;
};
